// src/components/ui/PaginationBar.jsx

import React from 'react';
import { PAGE } from './pageTheme';
import Button from './Button';

export default function PaginationBar({
  page,
  totalPages,
  totalItems,
  onPrevious,
  onNext,
  disabled = false,
  itemLabel = 'total',
}) {
  if (totalPages <= 1) return null;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 12,
      }}
    >
      <div style={{ fontSize: 13, color: PAGE.colors.muted, fontWeight: 500 }}>
        Page <strong style={{ color: PAGE.colors.navy }}>{page}</strong> of{' '}
        <strong style={{ color: PAGE.colors.navy }}>{totalPages}</strong>
        {typeof totalItems === 'number' && (
          <span> ({totalItems} {itemLabel})</span>
        )}
      </div>

      <div style={{ display: 'flex', gap: 8 }}>
        <Button
          variant="outline"
          size="sm"
          onClick={onPrevious}
          disabled={page === 1 || disabled}
        >
          Previous
        </Button>

        <Button
          variant="outlineActive"
          size="sm"
          active={page < totalPages}
          onClick={onNext}
          disabled={page === totalPages || disabled}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
